import type { PInlineNotificationProps } from "@porsche-design-system/components-react"
import type { FinancingNotification } from "./FinancingNotification"

export function mapInlineNotificationState(
	severity: FinancingNotification["severity"],
): PInlineNotificationProps["state"] {
	switch (severity) {
		case "error":
			return "error"
		case "warning":
			return "warning"
		default:
			return "info"
	}
}
